import { render, staticRenderFns } from "./WarehouseQueue.vue?vue&type=template&id=c1339e8a&scoped=true&"
import script from "./WarehouseQueue.vue?vue&type=script&lang=js&"
export * from "./WarehouseQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1339e8a",
  null
  
)

export default component.exports